import React, { useEffect, useRef, useState } from 'react';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import CallIcon from '@mui/icons-material/Call';
import CallEndIcon from '@mui/icons-material/CallEnd';
import Button from 'components/Button';
import { formatDuration, getName } from 'utils';
import CallerID from './CallerID';
import DialPad from './DialPad';
import Collapse from '@mui/material/Collapse';
import DialpadIcon from '@mui/icons-material/Dialpad';

const IncomingCall = ({ onAccept, onReject, onHangUp, call }) => {
  const [seconds, setSeconds] = useState(0);
  const [active, setActive] = useState(false);
  const [showDialer, setShowDialer] = useState(false);
  const timer = useRef();

  const { parameters, customParameters } = call;

  const params = Object.fromEntries(customParameters.entries());

  useEffect(() => {
    call.on('accept', handleAccept);
    call.on('reject', handleReject);
  }, []);

  const handleAccept = () => {
    console.log('Accepted call');
    setActive(true);
  };

  const handleReject = () => {
    console.log('call rejected');
  };

  useEffect(() => {
    if (active) {
      timer.current = setInterval(() => {
        setSeconds((seconds) => seconds + 1);
      }, 1000);
      return () => clearInterval(timer.current);
    }
  }, [active]);

  const toggleDialer = () => {
    setShowDialer((prev) => !prev);
  };

  const onDialInput = (number) => {
    call.sendDigits(String(number));
  };

  return (
    <Box p={3} textAlign="center">
      <Stack mb={2} spacing={1}>
        <Typography fontWeight={500} variant="subtitle1">
          Incoming Call
        </Typography>
        {active && (
          <Typography textAlign="center" fontWeight={500}>
            {formatDuration(seconds * 1000)}
          </Typography>
        )}
      </Stack>
      <Collapse in={!showDialer} mb="auto">
        <CallerID
          name={getName(params)}
          callSid={call.parameters.CallSid}
          from={params.primary_phone}
        />
      </Collapse>
      <Collapse in={showDialer}>
        <DialPad canDial={false} onChange={onDialInput} mode="dtmf" />
      </Collapse>
      {active ? (
        <Stack spacing={2}>
          <Stack
            direction="row"
            spacing={2}
            alignItems="center"
            justifyContent="center"
          >
            <IconButton
              size="large"
              active={showDialer}
              onClick={toggleDialer}
              color="primary"
            >
              <DialpadIcon />
            </IconButton>
            <IconButton
              sx={{
                'bgcolor': 'error.main',
                'color': 'white',
                '&:hover': {
                  bgcolor: 'error.dark',
                },
              }}
              size="large"
              color="error"
              onClick={onHangUp}
            >
              <CallEndIcon />
            </IconButton>
          </Stack>
        </Stack>
      ) : (
        <Stack
          direction="row"
          spacing={2}
          justifyContent="space-around"
          alignItems="center"
        >
          <Button
            rounded
            fullWidth
            color="success"
            startIcon={<CallIcon />}
            onClick={onAccept}
          >
            Accept
          </Button>
          <Button
            rounded
            fullWidth
            color="error"
            startIcon={<CallEndIcon />}
            onClick={onReject}
          >
            Decline
          </Button>
        </Stack>
      )}
    </Box>
  );
};

export default IncomingCall;
